import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Spring/FractionsB/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'FractionsB',
  field: 'Number',
  weeks: [4, 5],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/FractionsB/1MultiplyAUnitFractionByAnInteger" */ './1MultiplyAUnitFractionByAnInteger'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/FractionsB/2MultiplyANonUnitFractionByAnInteger" */ './2MultiplyANonUnitFractionByAnInteger'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/FractionsB/3MultiplyAMixedNumberByAnInteger" */ './3MultiplyAMixedNumberByAnInteger'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/FractionsB/4CalculateAFractionOfAQuantity" */ './4CalculateAFractionOfAQuantity'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/FractionsB/5FractionOfAnAmount" */ './5FractionOfAnAmount'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(/* webpackChunkName: "Year5/Spring/FractionsB/6FindTheWhole" */ './6FindTheWhole')
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/FractionsB/7UseFractionsAsOperators" */ './7UseFractionsAsOperators'
        )
    })
  ]
});
export default Block;
